<template>
  <div class="portfolio-enterprises">
    <div
      v-for="item in EnterprisesCards"
      :key="item.id"
      class="portfolio-enterprise-item"
    >
      <div class="portfolio-enterprise-info">
        <img :src="item.logo" class="portfolio-logo" />

        <h5>{{ item.name }}</h5>

        <p>{{ item.short_description }}</p>

        <v-btn depressed color="primary" @click="goToPageDetail(item.href)">
          <span v-html="$t('global.learn_more')"></span>
          <v-icon class="icon-flecha-derecha"></v-icon>
        </v-btn>
      </div>

      <div>
        <img :src="item.image_card" class="portfolio-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    EnterprisesCards: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    goToPageDetail(href) {
      this.$router.push({
        name: "Enterprise",
        params: { href },
      });
    },
  },
};
</script>

<style scoped>
.portfolio-enterprises {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.portfolio-enterprise-item {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: center;
  padding: 32px;
  background: #ffffff;
  border-radius: 12px;
}

.portfolio-enterprise-item:nth-child(even) .portfolio-enterprise-info {
  order: 2;
}

.portfolio-enterprise-info {
  text-align: center;
}

.portfolio-logo {
  max-width: 120px;
  max-height: 80px;
  object-fit: contain;
  margin-bottom: 24px;
}

.portfolio-image {
  width: 100%;
  max-height: 360px;
  object-fit: contain;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .portfolio-enterprise-item {
    grid-template-columns: 1fr;
  }

  .portfolio-enterprise-item:nth-child(even) .portfolio-enterprise-info {
    order: initial;
  }
}
</style>
